import { NumberFormat, toLocaleString as _toLocaleString, isUnitSupported, } from '.';
import { defineProperty } from '@formatjs/intl-utils';
if (!isUnitSupported('bit')) {
    defineProperty(Intl, 'NumberFormat', { value: NumberFormat });
    defineProperty(Number.prototype, 'toLocaleString', {
        value: function toLocaleString(locales, options) {
            return _toLocaleString(this, locales, options);
        },
    });
}
//# sourceMappingURL=polyfill.js.map